import { render, staticRenderFns } from "./evaluate-project-teacher.vue?vue&type=template&id=5923ac50&scoped=true"
import script from "./evaluate-project-teacher.vue?vue&type=script&lang=js"
export * from "./evaluate-project-teacher.vue?vue&type=script&lang=js"
import style0 from "./evaluate-project-teacher.vue?vue&type=style&index=0&id=5923ac50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923ac50",
  null
  
)

export default component.exports